import styled from "@emotion/styled";
import { Container } from "@mui/material";

export const LandingPageContainer = styled.div({
	display: "flex"
});

export const LandingPageSubContainer = styled(Container)(({ theme }) => ({
	flex: "1 1 auto",
	overflowX: "hidden",
	[theme.breakpoints.down("lg")]: {
		marginTop: "56px",
		overflowX: "inherit"
	}
}));

export const SidebarContainer = styled.div(({ theme }) => ({
	flex: "0 0 248px",
	[theme.breakpoints.down("lg")]: {
		position: "relative",
		zIndex: 1000,
		flex: "0 0 auto"
	}
}));
